import type { ReactNode } from "react";

/** /main 하위 페이지 공통 틀: 바깥 여백 + 카드 + 제목줄. 색은 테마 변수(--page-*)를 따른다 */
export default function PageShell({
  title,
  subtitle,
  actions,
  children,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="p-8">
      <div
        className="rounded-2xl p-6"
        style={{
          backgroundColor: "var(--page-surface-bg)",
          border: "1px solid var(--page-surface-border)",
          boxShadow: "var(--page-surface-shadow)",
        }}
      >
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-3xl font-bold" style={{ color: "var(--page-title)" }}>
              {title}
            </h2>
            {subtitle && (
              <p className="mt-1 text-sm" style={{ color: "var(--page-text)" }}>
                {subtitle}
              </p>
            )}
          </div>
          {actions}
        </div>
        {children}
      </div>
    </div>
  );
}
